export const GET_HELP_ME_DECIDE = 'GET_HELP_ME_DECIDE';
export const GET_HELP_ME_DECIDE_SUCCESS = 'GET_HELP_ME_DECIDE_SUCCESS';
export const GET_HELP_ME_DECIDE_FAILED = 'GET_HELP_ME_DECIDE_FAILED';
export const SET_RANGE_PRICE_POSITION= 'SET_RANGE_PRICE_POSITION';
